import LiveDefaultTemplate from '@/components/main/MyPlus/common/TemplateType/LiveDefaultTemplate';
import {useEffect, useState} from 'react';
import useMainStore from '@/stores/main';
import {LIVE_SLIDE_CNT, MAIN_LIST_CNT} from '@/constants/main';

const LiveContentType = ({
  data,
  selectedMode,
  rowCount,
  useSlider,
  hiddenStreamer,
  onChangeEnabled,
  log,
}) => {
  const {resizeMainLiveCount} = useMainStore();

  const [itemList, setItemList] = useState([]);
  const [displayedContent, setDisplayedContent] = useState([]);

  useEffect(() => {
    if (data) {
      const filteredList = data
        .filter((item) => !hiddenStreamer.includes(item.userId))
        .slice(0, MAIN_LIST_CNT);

      setItemList([...filteredList]);

      if (filteredList.length < 6) {
        onChangeEnabled(false);
      } else {
        onChangeEnabled(true);
      }
    }
  }, [data, hiddenStreamer]);

  useEffect(() => {
    if (useSlider) {
      setDisplayedContent([...itemList.slice(0, LIVE_SLIDE_CNT)]);
    } else {
      const visibleListCount = resizeMainLiveCount * rowCount;
      setDisplayedContent([...itemList.slice(0, visibleListCount)]);
    }
  }, [itemList, resizeMainLiveCount, useSlider, rowCount]);

  return (
    <>
      <LiveDefaultTemplate
        itemList={displayedContent}
        selectedMode={selectedMode}
        useSlider={useSlider}
        log={log}
      />
    </>
  );
};

export default LiveContentType;
